import React from 'react';
import styled from 'styled-components';
import stars from '../assets/stars.jpg'; // Import the image file

const ScrollbarContainer = styled.div`
  height: 100vh; // Adjust based on your requirement
  overflow-y: scroll;
  scrollbar-width: thin;
  scrollbar-color: #5E5E5E transparent; // Example: Visible color when active
  background-image: url(${stars});
  background-size: cover;

  &::-webkit-scrollbar {
    width: 16px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent; // Or another fitting background
  }
  
  &::-webkit-scrollbar-thumb {
    background-color: transparent; // Make it subtle or transparent
    border-radius: 8px;
    border: 4px solid rgba(0, 0, 0, 0); // Invisible border
  }
  
  &:hover {
    &::-webkit-scrollbar-thumb {
      background-color: #5E5E5E; // Change to a visible color on hover
      border: 4px solid transparent; // Optional: Adjust border for aesthetics
    }
  }
`;

const CustomScrollbar = ({ children }) => {
  return <ScrollbarContainer id='custom-scroll'>{children}</ScrollbarContainer>;
};

export default CustomScrollbar;
